import React from "react";
import { StyleSheet } from "@react-pdf/renderer";
import { CurriculumResult } from "api/types";
import { AggregatedCurriculum } from "./AggregatedCurriculum";

export const currResultsStyle = StyleSheet.create({
	container: {
		position: "absolute",
		top: 120,
		paddingHorizontal: 50,
	},
	title: {
		fontFamily: "Inter",
		fontStyle: "normal",
		fontWeight: "bold",
		fontSize: 32,
		marginBottom: 24,
	},
	areaContainer: {
		flexDirection: "column",
	},
	areaName: {
		fontFamily: "Inter",
		fontStyle: "normal",
		fontWeight: "medium",
		fontSize: 20,
		marginBottom: 8,
	},
	strandContainer: {
		flexDirection: "column",
	},
	strandName: {
		fontFamily: "Inter",
		fontStyle: "normal",
		fontWeight: "medium",
		fontSize: 16,
		marginBottom: 16,
	},
	curriculumContainer: {
		flexDirection: "row",
		paddingLeft: 25,
	},
	curriculumName: {
		fontFamily: "Inter",
		fontStyle: "normal",
		fontWeight: "medium",
		fontSize: 14,
		width: 130,
	},
	curriculumDetailsContainer: {
		flexDirection: "column",
		marginLeft: 27,
	},
	curriculumDetail: {
		flexDirection: "row",
	},
	curriculumDetailLeft: {
		flexDirection: "column",
	},
	curriculumCode: {
		fontFamily: "Inter",
		fontStyle: "normal",
		fontWeight: "semibold",
		fontSize: 13,
		marginLeft: 14,
		width: 81,
	},
	tickBox: {
		position: "absolute",
		width: 26,
		height: 26,
		bottom: 12,
		marginLeft: 14,
	},
	curriculumDetailRight: {
		flexDirection: "column",
		width: 390,
	},
	codeDescription: {
		fontFamily: "Inter",
		fontStyle: "normal",
		fontSize: 13,
		width: 390,
		marginBottom: 8,
		textAlign: "justify",
	},
	curriculumEntryContainer: {
		flexDirection: "column",
	},
	curriculumEntry: {
		flexDirection: "row",
		marginBottom: 8,
	},
	curriculumEntryName: {
		fontFamily: "Inter",
		fontStyle: "normal",
		fontWeight: "semibold",
		fontSize: 13,
		width: 140,
	},
	curriculumEntryContent: {
		fontFamily: "Inter",
		fontStyle: "normal",
		fontSize: 13,
		width: 250,
		textAlign: "justify",
	},
});

interface CurrResContentProps {
	data: CurriculumResult[];
}

export const CurriculumResultsContent: React.FC<CurrResContentProps> = ({
	data,
}): JSX.Element => <AggregatedCurriculum data={data} />;
